import { RESET_REQUESTED_REGION, SET_IS_FETCHING_REGION, SET_REGION } from 'reducers/actions-types';

export default function regionReducer(state = {
    /** @type {IRegion} */
    requested: null,
    isFetching: false,
    isSendingMail: false,
    /** @type {IRegion|boolean} */
    active: globals.config.region,
}, { type, region, isFetching }) {
    switch (type) {
        case SET_IS_FETCHING_REGION:
            return Object.assign({}, state, {
                isFetching,
            });
        case RESET_REQUESTED_REGION:
            return Object.assign({}, state, {
                requested: null,
            });
        case SET_REGION:
            return Object.assign({}, state, {
                requested: region,
                active: region.enabled ? region : state.active,
            });
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/reducers/modules/region/index.js